export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'opt' }
  },
  {
    title: that.$l('table_label_shipmentExpenseNo') || '费用单编号',
    field: 'shipmentExpenseNo',
    minWidth: 180,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_salesPerson') || '业务人员',
    field: 'salesPersonName',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_requestDate') || '申请日期',
    field: 'requestDate',
    minWidth: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_currencyTotalAmount') || '费用合计',
    field: 'v_currencyAmount',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'currencyAmount' },
  },
  {
    title: that.$l('table_label_payeeType') || '收款方类型',
    field: 'v_payeeType',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payee') || '收款方',
    field: 'payeeScmName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payeeScmBankName') || '收款方开户银行',
    field: 'bankName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payeeScmBankAccountName') || '收款方账户名称',
    field: 'bankAccountName',
    width: 260,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payeeScmBankAccountNo') || '收款方银行账号',
    field: 'bankAccountNo',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payeeScmBankAccountType') || '账户性质',
    field: 'v_bankAccountType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payeeScmBankAccountKind') || '账号类别',
    field: 'v_bankAccountKind',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_paymentMethod') || '付款方式',
    field: 'v_paymentMethod',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_shipmentExpenseStatus') || '费用单状态',
    field: 'shipmentExpenseStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' }
  },
  {
    title: that.$l('table_label_expensePayer') || '付款公司',
    field: 'expensePayerName',
    width: 250,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
